import React, { useEffect } from "react";
import Clarity from "@microsoft/clarity";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppRoutes from "./routes/AppRoute";
import "react-toastify/dist/ReactToastify.css";

export default function App() {

  useEffect(() => {
    const clarityId = process.env.REACT_APP_CLARITY_ID;

    if (clarityId) {
      Clarity.init(clarityId);
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
        />
      </div>
    </Router>
  );
}
